var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c("ReviewStep", {
            attrs: {
              "basic-data": _vm.formData.basicData,
              "juridical-documentation": _vm.formData.juridicalDocumentation,
              "economic-operational-data": _vm.formData.economicOperationalData,
              "linked-institutions": _vm.formData.linkedInstitutions,
              "additional-attachments": _vm.formData.additionalAttachments,
              "activity-areas": _vm.activityAreas,
              "organization-sizes": _vm.organizationSizes,
              disabled: true
            }
          }),
          _c(
            "b-row",
            { staticClass: "m-0 mt-2 no-print" },
            [
              _c("b-col", { attrs: { lg: "12" } }, [
                _c("div", { staticClass: "mt-1 mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "flex justify-end" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(255, 255, 255, 0.15)",
                              expression: "'rgba(255, 255, 255, 0.15)'",
                              modifiers: { "400": true }
                            }
                          ],
                          staticClass: "mt-1 mr-1 float-right",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/portal-cebas/credentialings/handlings"
                              )
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }